import { useState, useEffect } from "react";
import { Modal, Card, Table, message, Form, Spin } from "antd";
import { Row, Col, Space, Input, Typography, Drawer, Checkbox, Flex } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { columns, ACTIVE_ON, ACTIVE_OFF } from "./modal-microbiological.model";
import ModalMicrobiologicalManage from "./ModalMicrobiologicalManage.jsx";
import MicroService from "../../../service/Microbiological.service.js";

const microService = MicroService();
export default function ModalMicrobiological({
  show,
  close,
  values,
}) {
  const [form] = useForm();

  const [microbiologicalData, setCustomersData] = useState([]);
  const [microbiologicalDataWrap, setCustomersDataWrap] = useState([]);

  const [openModal, setOpenModel] = useState(show);
  const [loading, setLoading] = useState(true);

  const [openManage, setOpenManage] = useState(false);
  /** ข้อมูลที่กำลังแก้ไข (null = สร้างใหม่) */
  const [editSource, setEditSource] = useState(null);
  /** แสดงรายการที่ปิดใช้งานด้วยหรือไม่ */
  const [showAll, setShowAll] = useState(false);
  /** handle logic component */
  const handleClose = () => {
    setTimeout(() => {
      close(false);
    }, 140);

    //setTimeout( () => close(false), 200 );
  };

  const handleSearch = (value) => {
    if (!!value) {
      const kw = value.toLowerCase();
      /* เดิมค้นหาจาก micro_name ซึ่งไม่มีในรายการ (มีแต่ micro_master_name) */
      const f = microbiologicalData.filter(
        (d) =>
          d.micro_master_name?.toLowerCase().includes(kw) ||
          d.active_status?.toLowerCase().includes(kw) ||
          d.created_name?.toLowerCase().includes(kw)
      );

      setCustomersDataWrap(f);
    } else {
      setCustomersDataWrap(microbiologicalData);
    }
  };

  const handleChoose = (value) => {
    const {detail} = value ;
    values(detail);
      
    setOpenModel(false);
    
  };

  const manageSubmit = (v, isEdit) => {
    setOpenManage(false);
    setLoading(true);
    const action = isEdit ? microService.update : microService.create;

    action({ ...v })
      .then((_) => {
        message.success(isEdit ? "แก้ไขสำเร็จ" : "สร้างสำเร็จ");
        search();
      })
      .catch((err) => {
        console.warn(err);
        const data = err?.response?.data;
        message.error(data?.message || "error request");
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      });
  };

  /** เปิด drawer แก้ไข : โหลดข้อมูลเดิม + รายการพารามิเตอร์ */
  const handleEdit = (record) => {
    setLoading(true);
    microService
      .get(record.micro_code)
      .then((res) => {
        const { data, detail } = res.data || {};
        setEditSource({ ...(data || record), detail: detail || [] });
        setOpenManage(true);
      })
      .catch((err) => {
        const d = err?.response?.data;
        message.error(d?.message || "โหลดข้อมูลไม่สำเร็จ");
      })
      .finally(() => setLoading(false));
  };

  /** สลับเปิด/ปิดการใช้งาน — ส่งเฉพาะสถานะ ไม่แตะรายการพารามิเตอร์ */
  const handleToggle = (record, checked) => {
    const next = checked ? ACTIVE_ON : ACTIVE_OFF;
    setLoading(true);
    microService
      .update({ header: { micro_code: record.micro_code, active_status: next } })
      .then(() => {
        message.success(checked ? "เปิดใช้งานแล้ว" : "ปิดใช้งานแล้ว");
        search();
      })
      .catch((err) => {
        const d = err?.response?.data;
        message.error(d?.message || "เปลี่ยนสถานะไม่สำเร็จ");
        setLoading(false);
      });
  };

  /** setting initial component */
  const column = columns({ handleChoose, handleEdit, handleToggle });
  const search = (all = showAll) => {
    setLoading(true);
    microService
      .search(all ? { all: 1 } : {})
      .then((res) => {
        let { data } = res.data;
        setCustomersData(data);
        setCustomersDataWrap(data);
        // console.log(modalData, data)
      })
      .catch((err) => {
        console.warn(err);
        const data = err?.response?.data;
        message.error(data?.message || "error request");
        // setLoading(false);
      })
      .finally(() =>
        setTimeout(() => {
          setLoading(false);
        }, 400)
      );
  };

  useEffect(() => {
    if (!!openModal) {
      search();
      // console.log("modal-microbiological");
    }
  }, [openModal]);

  return (
    <>
      <Modal
        open={openModal}
        title="Select Microbiological"
        afterClose={() => handleClose()}
        onCancel={() => setOpenModel(false)}
        maskClosable={false}
        style={{ top: 20 }}
        width={1000}
        className="modal-microbiological"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Form.Item label="ค้นหา">
                      <Input
                        suffix={<SearchOutlined />}
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                        placeholder="Search Microbiological"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Flex align="center" justify="space-between" wrap="wrap" gap={8}>
                      <Typography.Link
                        onClick={() => {
                          setEditSource(null);
                          setOpenManage(true);
                        }}
                        className="ps-1"
                      >
                        <span className="hover:underline underline-offset-1">
                          Create Microbiological
                        </span>
                      </Typography.Link>
                      {/* เปิดดูรายการที่ปิดใช้งาน เพื่อเข้าไปแก้หรือเปิดกลับ */}
                      <Checkbox
                        checked={showAll}
                        onChange={(e) => {
                          setShowAll(e.target.checked);
                          search(e.target.checked);
                        }}
                      >
                        แสดงรายการที่ปิดใช้งาน
                      </Checkbox>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card style={{ minHeight: "60vh" }}>
              <Table
                bordered
                dataSource={microbiologicalDataWrap}
                columns={column}
                rowKey="micro_code"
                pagination={{
                  total: microbiologicalDataWrap.length,
                  showTotal: (_, range) =>
                    `${range[0]}-${range[1]} of ${microbiologicalData.length} items`,
                  defaultPageSize: 25,
                  pageSizeOptions: [25, 35, 50, 100],
                }}
                scroll={{ x: "max-content", y: 400 }}
                size="small"
              />
            </Card>
          </Space>
        </Spin>
        {openManage && (
          <Drawer
            destroyOnClose={true}
            title={editSource ? "Edit Microbiological" : "Create Microbiological"}
            width={"50vw"}
            className="custom-drawer-class"
            onClose={() => {
              setOpenManage(false);
              setEditSource(null);
            }}
            open={openManage}
            styles={{ body: { padding: "0px 24px 8px" } }}
            getContainer={() => document.querySelector(".modal-microbiological")}
          >
            <ModalMicrobiologicalManage
              source={editSource}
              submit={(val, isEdit) => manageSubmit(val, isEdit)}
            />
          </Drawer>
        )}
      </Modal>
    </>
  );
}
